<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form @submit="sendLink">
                <p class="text-muted"></p>

                <b-form-group>
                  <InputField name="email" type="email" :label="this.$t('email')" v-model="email" @error="fieldError"
                      :rules="{required:true, length: {min: 2}}"
                    />
                </b-form-group>

                <b-button variant="success" @click="sendLink" block>{{ $t('sendLink') }}</b-button>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Input from "@/components/form/Input"

export default {
  components: {
    InputField: Input
  },
  name: 'ForgotPassword',
  data: function() {
    return {
      email: "",
      errors: []
    }
  },
  methods: {
    sendLink(e) {
      e.preventDefault()

      if (this.checkForErrors()) {
          this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

          return
      }

      this.$http.post("/v1/user/resetpassword", {email: this.email}).then(resp => {
          if (resp.status == 200) {
              this.$router.push({path: "/login"})
          } else {
              this.$bvModal.msgBoxOk(this.$t('badHappened'))
          }
      }).catch(error => {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }

        this.$bvModal.msgBoxOk(this.$t('badHappened'))
      })
    },

    fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
  }
}
</script>
